import * as React from "react";

import { I18nProvider } from "../I18n";
import { SiteContext } from "../Site";
import { getOrCreateGlobalContext, CONTEXT_KEYS } from "../utils";

export interface ModulePreviewContextProps {
	languageId?: number;
}

export interface ModulePreviewProviderProps {
	children: JSX.Element;
	languageId?: number;
}

const defaultValue: ModulePreviewContextProps = {} as const;

const ModulePreviewContext =
	getOrCreateGlobalContext<ModulePreviewContextProps>(
		CONTEXT_KEYS.MODULE_PREVIEW,
		defaultValue,
	);

function ModulePreviewProvider(props: ModulePreviewProviderProps): JSX.Element {
	// extract children and use ...rest for the rest of the props
	const { children, ...rest } = props;
	const siteContextValue = React.useContext(SiteContext);
	const translations = siteContextValue?.translations;

	return (
		<ModulePreviewContext.Provider value={{ ...rest }}>
			<I18nProvider translations={translations}>{children}</I18nProvider>
		</ModulePreviewContext.Provider>
	);
}

export { ModulePreviewContext, ModulePreviewProvider };
